import { Box, Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { SubTitle } from '../../../common';
import useCustomerAddressMethod, { useDeleteCustomerAddressMethod, } from '../../hook/useCutomerAddressMethod';
import { useLanguage } from '../../../../context/language/language';
import ConfirmModal from '../../../common/Modal/ConfirmModal';

const Main = styled.div(({ theme }) => ({
  padding: theme.isMobile ? 16 : '24px 24px 24px 24px',
  width: theme.isMobile ? 'auto' : '375px',
  minHeight: 'auto',
  boxSizing: 'border-box'
}));

const TitleHeader = styled(SubTitle)(({ theme }) => ({
  color: theme.colors.grey700
}));

const Container = styled.div(({ theme }) => ({
  ...theme.fonts.textM,
  fontWeight: 400,
  padding: '8px 0px 24px 0px',
  color: theme.colors.grey550
}));

const Row = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const FlexRow = styled(Box)(({ width, margin, justifyContent }) => ({
  display: 'flex',
  flexDirection: 'row',
  width,
  margin,
  justifyContent: justifyContent ?? 'center',
  alignContent: 'center',
}));

const BtnCancel = styled(Button)(({ theme }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  width: '100%',
  marginRight: 8,
  backgroundColor: theme.colors.grey75,
  height: 44,
  textTransform: 'none',
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  width: '100%',
  backgroundColor: theme.colors.red600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  '&:hover': {
    backgroundColor: theme.colors.red400,
  },
  height: 44,
  textTransform: 'none',
}));

function CustomerDeleteAddress({
  onNext, onBack
}) {
  const { customerId, addressId, addressDetail } = useCustomerAddressMethod();
  const {
    isSuccess,
    isFailed,
    deleteAddress,
    resetDeleteAddress
  } = useDeleteCustomerAddressMethod();
  const word = useLanguage();

  const addressName = _.get(addressDetail, 'addressName', '-');

  useEffect(() => () => {
    resetDeleteAddress();
  }, []);

  useEffect(() => {
    if (isFailed) {
      onBack();
    }
    return () => {
      resetDeleteAddress();
    };
  }, [isFailed]);

  useEffect(() => {
    if (isSuccess) {
      onNext();
    }
    return () => {
      resetDeleteAddress();
    };
  }, [isSuccess]);

  return (
    <ConfirmModal
      isOpen={() => true}
      onClose={onBack}
      title={word('Address.Delete')}
      description={(<div dangerouslySetInnerHTML={{ __html: word('Address.Delete.Popup.Description').replace('%s', addressName.bold()) }} />)}
      onConfirm={() => deleteAddress(customerId, addressId)}
      confirmText={word('General.Delete')}
      closeText={word('General.Cancel')}
      isRed
    />
  );
}

export default CustomerDeleteAddress;
